module.exports = __webpack_public_path__ + "img/noble-level4-bg.f938d409.png";